<script>
    export default {
        props: {
            additional: {
                default: 0,
            },
        },
        data() {
            return {
                date: moment(),
                calculated: false,
            }
        },
        mounted() {
            this.interval = setInterval(() => {
                this.refresh();
            }, 1000)
        },
        methods: {
            refresh() {
                let today = moment();
                let next = this.getNextWorkingDay(
                    momentHoliday().add(this.additional + 1, 'days')
                );
                if (today.format('HHmmss') > 120000 && !this.additional) {
                    next = this.getNextWorkingDay(
                        next.add(1, 'day')
                    );
                }
                this.date = next;
                this.calculated = true;
            },
            getNextWorkingDay(date) {
                let isWeekend = this.isWeekend(date);
                while (date.isHoliday() || isWeekend) {
                    date.add(1, 'day');
                    isWeekend = this.isWeekend(date);
                }
                return date;
            },
            isWeekend(date) {
                return (date.format('dddd') == "Saturday" || date.format('dddd') == 'Sunday');
            }
        },
        render() {
            return this.$scopedSlots.default({
                'date': this.date,
                'calculated': this.calculated
            });
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/Components/Elements/NextDeliveryDate.vue